import { Paragraph } from 'theme-ui';

export function ErrorLabel({ message }: { message?: string }) {
  if (!message) {
    return null;
  }

  return <Paragraph sx={{ pt: 1, color: 'red' }}>{message}</Paragraph>;
}
